import { FC, PropsWithChildren } from 'react'

import { twMerge } from '~/lib'

type SearchFormSectionLayoutProps = PropsWithChildren<{
  title: string
  headerClassName?: string
  layoutClassName?: string
}>

export const SearchFormSectionLayout: FC<SearchFormSectionLayoutProps> = ({
  title,
  headerClassName,
  layoutClassName,
  children,
}) => {
  return (
    <div
      className={twMerge(
        'md:flex md:border-t md:border-grayBorder md:last:border-b',
        layoutClassName,
      )}
    >
      <h4
        className={twMerge(
          'flex w-full shrink-0 items-center bg-brand-bg px-4 py-2 text-body-bold md:w-36',
          headerClassName,
        )}
      >
        {title}
      </h4>
      {children}
    </div>
  )
}
